import React, { Component } from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, component_tool, framework_tool } from '@/tool';
let { Session, Storage, checkStrLength } = utils_tool;
import '@/styles/containers/workflow/procTask/index.less'
import { WizTableForm, WizDataAuthSelect } from '@/containers/common'

// import createColumns from "./auditHistoryColumns";
import AuditDetail from "./auditDetail";
import AuditPerson from "./authPerson";
import ApplyDetail from './auditeBizInfo/applyDetail'
import moment from "moment";
let { WizButton, WizLayout, WizDataTable, WizCard, WizCollapse, WizAntdForm, WizCustomSteps, WizModal, WizRow, WizCol, WizIcon, WizCommonSteps } = component_tool;
let { WizContainer } = framework_tool;
import { Spin } from 'antd'
import * as local_urls from '../../../constants/constants_url';
const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;
const { getPageData } = utils_tool;
const getParamRecord = (history) => {
  let record = {};
  if (history.location) {
    if (history.location.pathname === '/workflow/auditHistory') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('auditHistoryInfo', record)
      } else {
        record = Session.get('auditHistoryInfo') || {}
      }
      record['manager'] = false
    } else if (history.location.pathname === '/workflow/managerAuditHistory') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('managerAuditHistoryInfo', record)
      } else {
        record = Session.get('managerAuditHistoryInfo') || {}
      }

      record['manager'] = true
    }
  }
  return record
}
const _getValue = (type, key) => {
  const values = {
    auditType: {
      'ApplyCommon': '公共报名',
    },
  }
  return values[type][key] || ''
}
class AuditHisory extends WizContainer {

  componentName = 'AuditHisory';

  constructor(props) {
    super(props);
    let record = getParamRecord(this.props.history);
    this.state = {
      record: record,
      manager: record['manager'],
      businessAuditInfoList: [],
      identityInfoVisible: false,
      userIdentityInfoList: [],//申请人任职信息
      cardKey: 0,
      auditDetailInfo: {},
      businessInfo: {
        title: '',
        auditType: '',
        operatorName: '',
        operationTime: '',
        auditName: '',
      },
    }
  }

  _componentDidMount() {
    this._getData();
  }
  propsAndStateOnChange = {
    businessInfo: this._businessInfo.bind(this),
    businessAuditInfoList: this._businessAuditInfoList.bind(this),
    userIdentityInfoList: this._userIdentityInfoList.bind(this),
  }
  _userIdentityInfoList(nextProps, nextState) {

    let userIdentityInfoList = nextProps['userIdentityInfoList'];
    if (userIdentityInfoList && userIdentityInfoList['success']) {
      nextState['userIdentityInfoList'] = userIdentityInfoList['data']
      return true;
    } else {
      wizNotice.error(userIdentityInfoList && userIdentityInfoList['msg'] || '操作失败,请稍后尝试')
    }
    return false;
  }
  _businessAuditInfoList(nextProps, nextState) {
    let businessAuditInfoList = nextProps['businessAuditInfoList'];
    if (businessAuditInfoList && businessAuditInfoList['success']) {
      nextState['businessAuditInfoList'] = businessAuditInfoList['data']
      return true;
    } else {
      wizNotice.error(businessAuditInfoList && businessAuditInfoList['msg'] || '操作失败,请稍后尝试')
    }
    return false;
  }
  _businessInfo(nextProps, nextState) {
    let businessInfo = nextProps['businessInfo'];
    if (businessInfo && businessInfo['success']) {
      nextState['businessInfo'] = businessInfo['data']
      this.doActions([{
        path: 'userIdentityManagement/queryUserIdentityInfoList',
        payload: {
          key: 'userIdentityInfoList',
          apiParams: {
            personIds: [businessInfo['data']['operatorId']]
          }
        }
      },
      ]);
      return true;
    } else {
      wizNotice.error(businessInfo && businessInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false;
  }

  _getData() {
    const { record } = this.state
    if (record['managerType']) {
      this.doActions([{
        path: 'auditInfo/businessAuditInfoList',
        payload: {
          key: 'businessAuditInfoList',
          apiParams: {
            procInstId: record.procInstId
          }
        }
      }, {
        path: 'auditInfo/flowListByPage',
        payload: {
          key: 'flowList',
          apiParams: {
            procInstId: record.procInstId
          }
        }
      }, {
        path: 'auditInfo/businessInfo',
        payload: {
          key: 'businessInfo',
          apiParams: {
            procInstId: record.procInstId
          }
        }
      },]);
    } else {
      this.doActions([{
        path: 'auditInfo/businessAuditInfo',
        payload: {
          key: 'businessAuditInfoList',
          apiParams: {
            taskId: record.id
          }
        }
      }, {
        path: 'auditInfo/flowListByPage',
        payload: {
          key: 'flowList',
          apiParams: {
            procInstId: record.procInstId
          }
        }
      }, {
        path: 'auditInfo/businessInfo',
        payload: {
          key: 'businessInfo',
          apiParams: {
            procInstId: record.procInstId
          }
        }
      },
      ]);
    }
  }
  _renderContentRows(lv = []) {
    let list = []
    lv.forEach((element, index) =>
      list.push(
        <WizRow className='audit-row-item'>
          <WizCol className='col-item' span={2} offset={0}>组织:</WizCol>
          <WizCol span={16}>{element['orgPathName']}</WizCol>
          <WizCol className='col-item' span={2} offset={0}>岗位:</WizCol>
          <WizCol span={4}>{element['positionName']}</WizCol>
        </WizRow>
      )
    )

    return list
  }
  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='audit-row-item'>
        <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={9}>{rv}</WizCol>
      </WizRow>
    )
  }
  _timeConvret(time) {
    if (time && time != undefined) {
      return moment(time).format("YYYY-MM-DD HH:mm")
    } else {
      return ''
    }
  }
  _apply(auditType) {
    let { record } = this.state
    if (record['processDefKey'] === 'ApplyCommon' ||record['key'] === 'ApplyCommon') {
      return <ApplyDetail procInstId={record['procInstId']} />
    }
    return null
  }

  _convertColor(name) {
    let b = 1
    for (let index = 0; index < name.length; index++) {
      b = b * name.charCodeAt(index) % 16777216

    }
    let ab = (b / 65535 ^ 0) % 255
    let bc = (b / 255 ^ 0) % 255
    let cd = ~~b % 255
    return `#${ab.toString(16)}${bc.toString(16)}${cd.toString(16)}`
  }
  _AuditDetail() {
    const { businessAuditInfoList, auditDetailInfo, cardKey } = this.state
    if (businessAuditInfoList && businessAuditInfoList instanceof Array && businessAuditInfoList.length > 0) {
      let tabList = []
      businessAuditInfoList.forEach((element, index) => {
        tabList.push({
          key: index,
          tab: element.currentTaskName || ''
        }
        )
      })
      let cardProps = {
        // style: { marginLeft: 2, height: 100 },
        key: 5,
        headStyle: {
          // height: '33%',
          fontSize: 12,
          color: 'rgba(0, 0, 0, 0.85)',
          // fontWeight: 500,
          background: '#FFFFFF',
          borderBottom: 1,
        },
        bodyStyle: {
          textAlign: 'center', verticalAlign: 'middle', padding: 1, margin: 1, //height: '67%'
        },
      };
      return (
        <WizCard
          {...cardProps}
          tabList={tabList}
          activeTabKey={cardKey}
          onTabChange={key => {
            this.setState({ cardKey: key });
          }}
        >
          <>
            <AuditDetail key={cardKey} record={businessAuditInfoList[cardKey]} />
          </>
        </WizCard>
      )
    } else {
      return null;
    }
  }

  _stepInfos = () => {

    const { flowList } = this.props;
    const { manager } = this.state;
    const dataItems = getPageData(flowList.data);
    let cardProps = {
      title: '审批记录',
      // icon: 'solution',
      headStyle: { backgroundColor: '#f8f8f8', color: '#3a3a3a' },
      borderBottom: 1,
      //extra: <WizButton type="primary"><WizIcon type="sort-ascending" />调整顺序</WizButton>
    }
    let stepsProps = {
      style: { paddingTop: 50 }
    }
    let stepProps = {
    }
    let renderItem = (data, index, datas, callback) => {
      callback({
        dot: <WizIcon type="info-circle" theme="twoTone" twoToneColor={this._convertColor(data['assignee'])} style={{ fontSize: '30px' }} />
      })

      return (
        <div
          style={{
            height: 100,
            width: 200,
            backgroundColor: 'rgb(248, 248, 248)',
            position: 'relative',
            top: -34,
            marginLeft: 10
          }}
        >
          <WizRow><WizCol span={12} offset={1}>
            {data['deleteReason'] ? data['assignee']
              : manager ? <AuditPerson/> : null
            }
          </WizCol>
            <WizCol span={11}> {data['name']}</WizCol>
          </WizRow>
          <WizRow>
            <WizCol span={24} offset={1}>{data['endTime']}</WizCol>
          </WizRow>
          <WizRow>
            <WizCol span={24} offset={1}>{data['comment']}</WizCol>
          </WizRow>
        </div>
      )
    }

    return (
      <WizCommonSteps
        timelineProps={stepsProps}
        itemProps={stepProps}
        cardProps={cardProps}
        datas={dataItems['list']}
        renderItem={renderItem}
      />
    )
  }

  _render() {
    const { flowList, auditInfoLoading, procTaskTodoLoading, userIdentityManagementLoading } = this.props;
    const { businessInfo, record, userIdentityInfoList, identityInfoVisible } = this.state;
    const dataItems = getPageData(flowList.data);
    let identityInfo = '';
    if (userIdentityInfoList instanceof Array && userIdentityInfoList.length > 0) {
      identityInfo = userIdentityInfoList.map(p => `${p['orgPathName']}(${p['positionName']})`).join(",")
    }
    // const dataTableProps = {
    //   columns: createColumns(this),
    //   rowKey: "id",
    //   dataItems,
    //   selectType: "checkbox",
    //   showNum: false,
    //   isScroll: true,
    //   onChange: ({ pageNum, pageSize }) => {
    //     this._getData({ current: pageNum, size: pageSize });
    //   }
    // };
    //let img = `/api${urls.kUrlProcTaskCurrTaskImg}?procInstId=${record.procInstId}&access-token=${Storage.getStorage("token")}`;
    return (
      <div>

        <Spin tip={'加载中'} spinning={auditInfoLoading || procTaskTodoLoading || userIdentityManagementLoading}>
          <WizCard title="审核详情">

            <WizCollapse className='audit-collapse'
              expandIconPosition='right'
              defaultActiveKey={[0]}
            >
              <WizCollapse.Panel key={0} header={'基本信息'} className='panel-item'>

                {/* {this._renderContentRow('任务名称', `${businessInfo.title}`, '审核类型', `${_getValue('auditType', businessInfo['auditType'])}`)} */}
                {this._renderContentRow('任务名称', `${businessInfo.title}`, '状态', `${businessInfo.currentTask}`)}
                {this._renderContentRow('申请人', `${businessInfo.operatorName}`, '申请时间', `${this._timeConvret(businessInfo['operationTime'])}`)}

                <WizRow className='audit-row-item'>
                  <WizCol className='col-item' span={3} offset={1}>{'申请人任职：'}</WizCol>
                  <WizCol span={20}>{`${checkStrLength(identityInfo, 60)}`}
                    {identityInfo.length > 60 ? <WizButton type="button" className="look-ant-btn"
                      onClick={e => {
                        this.setState({ identityInfoVisible: true });
                      }}>
                      查看详细任职
    </WizButton> : null}</WizCol>
                </WizRow>
                <WizModal width={900} title="查看详细任职" visible={identityInfoVisible}
                  footer={<WizButton onClick={e => this.setState({ identityInfoVisible: false })}>关 闭</WizButton>}
                  onCancel={() => {
                    this.setState({ identityInfoVisible: false })
                  }}>
                  {this._renderContentRows(userIdentityInfoList)}

                </WizModal>
              </WizCollapse.Panel>
              <WizCollapse.Panel key={3} header={'申请信息'} className='panel-item'>
                {this._apply(businessInfo['auditType'])}
              </WizCollapse.Panel>
              <WizCollapse.Panel key={1} header={'审核信息'} className='panel-item'>
                <WizLayout className="sider-layout" >
                  <WizLayout className="sider-layout" >
                    <WizLayout.Sider width='300px' trigger={null} breakpoint="lg" collapsible={false} className="sider">
                      {this._stepInfos()}
                    </WizLayout.Sider>
                    <WizLayout.Content className="content" >
                      {/* <WizDataTable {...dataTableProps} />
                      <div className="pagination">
                        <WizDataTable.Pagination {...dataTableProps} />
                      </div> */}
                      {this._AuditDetail()}
                    </WizLayout.Content>

                  </WizLayout>
                  <WizLayout.Footer >
                    <WizRow>
                      <WizCol>
                        {/* <img src={img} /> */}
                      </WizCol>
                    </WizRow>
                  </WizLayout.Footer>
                </WizLayout>
              </WizCollapse.Panel>
            </WizCollapse>
          </WizCard>
        </Spin>
      </div>
    )

  }
}

const mapStateToProps = (state, ownProps) => {

  const { auditInfo, procTaskTodo, userIdentityManagement } = state;

  const flowList = modelUtils.getModelEntity(auditInfo, "flowList");
  const businessInfo = modelUtils.getModelEntity(auditInfo, "businessInfo");
  const businessAuditInfoList = modelUtils.getModelEntity(auditInfo, "businessAuditInfoList");
  const userIdentityInfoList = modelUtils.getModelEntity(userIdentityManagement, "userIdentityInfoList");


  const load = modelUtils.getLoadingState(state, ['auditInfo', 'procTaskTodo', 'userIdentityManagement']);
  return {
    flowList: flowList,
    businessInfo: businessInfo,
    businessAuditInfoList: businessAuditInfoList,
    userIdentityInfoList: userIdentityInfoList,
    ...load
  }
};

export default connect(mapStateToProps)(AuditHisory)
